import { functionNamesDeep } from "./utils";
var facadeToCommands = {};
export function registerFacadeCommands(facadeId, commands) {
    facadeToCommands[facadeId] = commands;
}
export function deregisterFacadeCommands(facadeId) {
    delete facadeToCommands[facadeId];
}
export function createCommandsActionTypeNames(facade) {
    var commands = facadeToCommands[facade.facadeId];
    var actionTypes = {};
    for (var _i = 0, _a = functionNamesDeep(commands); _i < _a.length; _i++) {
        var methodName = _a[_i];
        actionTypes[methodName] = facade.createActionName(methodName);
    }
    return actionTypes;
}
